import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/Components/AppShell.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["AssistantProvider"] */ "/vercel/path0/app/Components/Assistant/AssistantContext.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/Components/Assistant/AssistantModalHost.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["AuthProvider"] */ "/vercel/path0/app/Components/AuthProvider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["CoursePeekProvider"] */ "/vercel/path0/app/Components/CoursePeek/CoursePeekProvider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/Components/DevToolsBranding.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/Components/PostHogPageViewTracker.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PostHogProvider"] */ "/vercel/path0/app/Components/PostHogProvider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/Components/ScrollManager.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/Components/ThemeProvider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["UiPreferencesProvider"] */ "/vercel/path0/app/Components/UiPreferencesProvider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["UniversalSearchProvider"] */ "/vercel/path0/app/Components/UniversalSearch/UniversalSearchProvider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/Components/WebMcpProvider.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/app/globals.css");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/font/google/target.css?{\"path\":\"app/layout.tsx\",\"import\":\"Inter\",\"arguments\":[{\"subsets\":[\"latin\"]}],\"variableName\":\"inter\"}");
